import { render, staticRenderFns } from "./TermsOfUseModal.vue?vue&type=template&id=87a3063c"
import script from "./TermsOfUseModal.vue?vue&type=script&lang=js"
export * from "./TermsOfUseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports